const STYTCH_PUBLIC_TOKEN = process.env.NEXT_PUBLIC_STYTCH_PUBLIC_TOKEN;

export default STYTCH_PUBLIC_TOKEN;
